import type { FC } from 'react';
import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import type { FilterSize } from './filterSize';
import { DEFAULT_FILTER_SIZE } from './filterSize';

interface SearchInputProps {
  value: string;
  onChange: (val: string) => void;
  placeholder?: string;
  size?: FilterSize;
}

const SearchInput: FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = 'Search by name or Hypothesis',
  size = DEFAULT_FILTER_SIZE,
}) => {
  return (
    <TextField
      size={size}
      placeholder={placeholder}
      value={value}
      onChange={(e) => { onChange(e.target.value); }}
      sx={{ flex: 1, minWidth: 200 }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchInput;
